import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { change, Field, isDirty, reduxForm } from 'redux-form';

import { Typography, Button } from '@material-ui/core';

import { FormActionButtons, Input, TextareaInput } from '../index';

import { EMAIL_BODY, EMAIL_INFO, EMAIL_SUBJECT } from './constants';

import { useStyles } from './styles';

const initialValues = {
  id: '',
  subject: EMAIL_SUBJECT,
  body: EMAIL_BODY
};

const EmailSettingsForm = ({ handleSubmit, isDirty, changeFieldValue }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const setDefaultEmail = () => {
    changeFieldValue('subject', EMAIL_SUBJECT);
    changeFieldValue('body', EMAIL_BODY);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.emailSettingsWrapper}>
        <div className={classes.emailSettings}>
          <Typography variant="h1" className={classes.title}>
            {t('Email settings')}
          </Typography>
          <form onSubmit={handleSubmit}>
            <Field
              name="subject"
              className={classes.input}
              inputProps={{ maxLength: 255 }}
              placeholder="Subject"
              label="Subject *"
              component={Input}
            />
            <Field
              name="body"
              className={classes.input}
              maxLength="2000"
              rows={5}
              rowsMax={100}
              placeholder="Body"
              label="Body *"
              isAutosize={true}
              component={TextareaInput}
            />
            <div className={classes.actionButtons}>
              <Button
                type="button"
                variant="outlined"
                classes={{
                  root: classes.resetButton
                }}
                onClick={setDefaultEmail}
              >
                {t('Set default')}
              </Button>

              <FormActionButtons
                isDisabledAction={!isDirty}
                cancelPath="/"
                actionLabel="Save"
              />
            </div>
          </form>
        </div>
      </div>

      <div className={classes.info}>
        <Typography variant="h1" className={classes.title}>
          {t('Info')}
        </Typography>
        <div className={classes.infoList}>
          {Object.keys(EMAIL_INFO).map(key => (
            <p className={classes.infoItem}>
              <b>{`{${key}}`}</b> - {t(EMAIL_INFO[key])};
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isDirty: isDirty('emailSettingsForm')(state)
});

const mapDispatchToProps = dispatch => ({
  changeFieldValue: (field, value) => {
    dispatch(change('emailSettingsForm', field, value));
  }
});

export default reduxForm({
  form: 'emailSettingsForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(EmailSettingsForm));
